<template>
  <DxPopup @hidden="onHidden" :visible="showMenuPop" :show-close-button="true" :show-title="true" :title="'Menu Select'" height="700px" width="1000px" container=".sys0020-main">
    <v-row no-gutters fill-height>
      <v-col cols="12" class="pa-0">
        <v-row no-gutters fill-height>
          <v-col cols="12" class="pa-0">
            <i-card-top class="d-md-flex"
              :useBtnList="[
                'btnSearch',
                'btnSelect'
              ]"
              @btnSearch="searchMenus()"
              @btnSelect="selectMenus()"
            >
              <template v-slot:body>
                <div />
              </template>
            </i-card-top>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters fill-height style="height: calc(100% - 48px);">
      <v-col cols="12" class="pa-0" style="height: 100%;">
        <DxTreeList
          id="menuList"
          height="100%"
          :ref="menuListRef"
          :data-source="menuList"
          :hover-state-enabled="true"
          :allow-column-resizing="true"
          :allow-column-reordering="true"
          :row-alternation-enabled="true"
          :show-borders="true"
          :width="grid.width"
          :show-row-lines="true"
          key-expr="menuId"
          parent-id-expr="prtMenuId"
          :focused-row-enabled="true"
          :column-hiding-enabled="false"
          :autoExpandAll="true"
          :selection="{ mode:'multiple' , recursive:true }"
          :selected-row-keys="rowKey"
          :expanded-row-keys="expandedRowKeys"
        >
          <DxScrolling column-rendering-mode="virtual"/>
          <DxColumn data-field="ename" caption="Menu Name" width="auto" data-type="string" alignment="left" :allow-editing="false" sort-order="asc" />
          <DxPaging :enabled="true" :page-size="10"/>
        </DxTreeList>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup'
import { DxTreeList } from 'devextreme-vue/tree-list'
import { DxColumn  } from 'devextreme-vue/data-grid'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'

import { getPopMenus } from '@/api/system/authManage'

export default {
  name: 'sys0200MenuPop',
  mixins: [baseview, BaseDataGrid],
  props: {
    showMenuPop: {
      type: Boolean,
      default() {
        return false
      }
    },
    userId: {
      type: String,
      default() {
        return ''
      }
    }
  },
  components: {
    DxPopup,
    DxTreeList,
    DxColumn
  },
  data() {
    return {
      menuListRef: 'menuListRef',
      menuList: [],
      rowKey: [],
      expandedRowKeys:[]
    }
  },
  computed: {
    menusInstance() {
      return this.GetDataGrid(this.menuListRef)
    },
  },
  watch: {
    'showMenuPop': {
      handler(value, oldValue) {
        if(value) {
          this.searchMenus()
        }
      },
      immediate: true
    }
  },
  methods: {
    searchMenus() {
      this.menuList = []
      this.rowKey = []
      this.expandedRowKeys = []

      const param = {
        sysCd: this.$store.state.system.sysCd,        
        userId: this.userId
      }
      

      getPopMenus(param).then(res => {
        // console.log('res', res)

        this.menuList = res.list
      })
    },

    selectMenus() {
      let selectedMenus = this.menusInstance.getSelectedRowsData('all')
      let result = []

      if(selectedMenus.length < 1) {
        this.vToastify(this.$t('SelectCheck'), 'warn')
        return
      }

      for(let i = 0; i  < selectedMenus.length; i++) {
        result.push(selectedMenus[i])

        if(!this.$_.some(result, { menuId: selectedMenus[i].prtMenuId })
          && this.menusInstance.getNodeByKey(selectedMenus[i].prtMenuId)) {
          result.push(this.menusInstance.getNodeByKey(selectedMenus[i].prtMenuId).data)
        }
      }

      for(let i = 0; i  < result.length; i++) {
        result[i].sysCd = this.$store.state.system.sysCd
        result[i].authCd = this.authCd
      }
      
      // console.log('result', result)

      this.$emit('selected', result)
      this.$emit('update:showMenuPop', false)
    },
    onHidden(e) {
      this.$emit('update:showMenuPop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
//.v-btn {
//    text-transform: unset !important;
//}
</style>